import useUserId from '@/hooks/useUserId';
export default function usePersonalizeName() {
  const userId = useUserId();
  const personalizeName = (id: string, name: string) =>
    userId === id ? 'You' : name;
  return personalizeName;
}
